import moment from "moment/moment";

const columns = [
  {
    title: "A/C No.",
    dataIndex: "Login",
  },
  {
    title: "Symbol",
    dataIndex: "Symbol",
  },
  {
    title: "PNL",
    dataIndex: "Profit",
  },
  {
    title: "Volume",
    dataIndex: "Volume",
  },
  {
    title: "Stop Loss",
    dataIndex: "StopLoss",
  },
  {
    title: "Take Profit",
    dataIndex: "TakeProfit",
  },
  {
    title: "Time",
    dataIndex: "Time",
    render: (text) => moment(text).format('DD-MM-YYYY LT'),
  },
];

export default columns;